import { Link } from 'react-router-dom';
import { siteConfig } from '../../../config/site';
import { zonas } from '../../../data/zonas';

const ServiceAreas = () => {
  const isPortoSite = siteConfig.domain === 'alphacanalizacoesporto.pt';
  const isClimatizacaoSite = siteConfig.domain === 'alphaclimatizacao.pt';

  // No site de climatização as localidades com página própria ficam clicáveis
  const zonaPorNome = new Map(zonas.map((zona) => [zona.nome.toLowerCase(), zona]));

  const Area = ({ nome }: { nome: string }) => {
    const zona = isClimatizacaoSite ? zonaPorNome.get(nome.toLowerCase()) : undefined;

    if (!zona) {
      return (
        <span className="px-3 py-1 bg-white border border-gray-200 rounded-full text-sm text-gray-700">
          {nome}
        </span>
      );
    }

    return (
      <Link
        to={`/ar-condicionado-${zona.slug}`}
        className="px-3 py-1 bg-white border border-blue-300 text-blue-700 hover:bg-blue-600 hover:text-white hover:border-blue-600 rounded-full text-sm transition-colors inline-flex items-center gap-1"
        title={`Ar condicionado ${zona.preposicao} ${zona.nome}`}
      >
        {nome}
        <i className="ri-arrow-right-up-line text-xs"></i>
      </Link>
    );
  };

  const lisbonAreas = [
    'Amadora', 'Loures', 'Odivelas', 'Benfica', 'Algés', 'Oeiras', 'Cacém', 'Sintra', 'Cascais', 
    'Belém', 'Restelo', 'Ajuda', 'Alcântara', 'Santos', 'Príncipe Real',
    'Marquês de Pombal', 'Avenidas Novas', 'Alvalade', 'Lumiar', 'Olivais', 'Parque das Nações'
  ];

  const margemSulAreas = [
    'Almada', 'Seixal', 'Barreiro', 'Moita', 'Setúbal', 'Montijo', 'Alcochete',
    'Corroios', 'Pragal', 'Cacilhas', 'Trafaria', 'Costa da Caparica',
    'Charneca de Caparica', 'Sobreda', 'Fernão Ferro', 'Sesimbra'
  ];

  const portoAreas = [
    'Cedofeita', 'Bonfim', 'Campanhã', 'Paranhos', 'Lordelo do Ouro', 'Foz do Douro',
    'Boavista', 'Ramalde', 'Nevogilde', 'Aldoar', 'Miragaia', 'Sé', 'Massarelos'
  ];

  const portoMetroAreas = [
    'Vila Nova de Gaia', 'Matosinhos', 'Gondomar', 'Valongo', 'Maia', 'Vila do Conde',
    'Póvoa de Varzim', 'Espinho', 'Santa Maria da Feira', 'São João da Madeira'
  ];

  if (isPortoSite) {
    return (
      <section className="py-12 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
              Zonas Atendidas
            </h2>
            <p className="text-base text-gray-600">
              Porto e Área Metropolitana com técnicos locais
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {/* Porto */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Porto</h3>
              <div className="flex flex-wrap gap-2">
                {portoAreas.map((area, index) => (
                  <Area key={index} nome={area} />
                ))}
              </div>
            </div>

            {/* Área Metropolitana */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Área Metropolitana</h3>
              <div className="flex flex-wrap gap-2">
                {portoMetroAreas.map((area, index) => (
                  <Area key={index} nome={area} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
            Zonas Atendidas
          </h2>
          <p className="text-base text-gray-600">
            Lisboa e Margem Sul com técnicos locais
          </p>
          {isClimatizacaoSite && (
            <Link to="/zonas" className="inline-flex items-center gap-2 mt-3 text-blue-600 hover:text-blue-700 font-semibold text-sm">
              Ver todas as zonas <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Lisboa */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Lisboa</h3>
            <div className="flex flex-wrap gap-2">
              {lisbonAreas.map((area, index) => (
                <Area key={index} nome={area} />
              ))}
            </div>
          </div>

          {/* Margem Sul */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Margem Sul</h3>
            <div className="flex flex-wrap gap-2">
              {margemSulAreas.map((area, index) => (
                <Area key={index} nome={area} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
